const endpoints = {
  prodPortal: 'https://api.capitalirrigation.com/',
  stagingPortal: 'https://api-dev.capitalirrigation.com/',
  devAPI: 'http://localhost:8000/api/',
  devPortal: 'http://localhost:8080/',
  apps: 'apps/',
  getConstants: 'get-constants/',
  // test...
  categoryOptions: 'work/category-options/',
  categories: 'work/categories/',
  entries: 'timesheets/entries/',
  workedon: 'timesheets/worked-on/',
  tomorrow: 'tomorrow/',
  receipts: 'receipts/receipts/',
  receiptLines: 'receipts/lines/',
  receiptPaymentMethods: 'receipts/payment-methods/',
  equipmentReceiptTypes: 'receipts/equipment-receipt-types/',

  // Notices
  sendEmail: 'send-email/',
  notices: 'notices/',
  irrigationPreviewList: 'irrigation-preview-list/',
  lawnPreviewList: 'lawn-preview-list/',
  snowPreviewList: 'snow-preview-list/',

  // Accounting
  invoices: 'invoices/',
  emailInvoice: 'email-invoice/',
  emailInvoiceOutstandingNotice: 'email-outstanding-notice/',
  emailInvoiceOverdueNotice: 'email-overdue-notice/',
  downloadInvoice: 'download-invoice/',
  previewInvoice: 'preview-invoice/',
  arrearsLetter: 'arrears-letter/',
  invoiceLineItems: 'invoice-line-items/',
  invoiceLookup: 'invoice-lookup/',
  invoicePayments: 'invoice-payments/',
  reconciliations: 'reconciliations/',
  accounts: 'accounts/',
  deposits: 'deposits/',
  accountingDashboard: 'accounting-dashboard/',
  arReport: 'ar-report/', // expects a GET params: ?date=YYYY-MM-DD

  // Bookkeeping
  journalEntry: 'journal-entries/',
  journalEntryLineItems: 'journal-entry-line-items/',

  // Budgeting
  budgetCategories: 'budget-categories/',
  budgets: 'budgets/',
  budgetLineItems: 'budget-line-items/',

  // Expenses
  expenses: 'expenses/',
  expenseLineItems: 'expense-line-items/',

  // Auth
  logout: 'logout',
  users: 'users/',
  userData: 'user-data/',
  profiles: 'profiles/',
  changePassword: 'change-password/',
  resetPassword: 'reset-password/',
  forgotPassword: 'forgot-password/',
  newUserPassword: 'new-user-password/',
  getUserProfile: 'user-profile/',
  appAccess: 'app-access/',

  // Staffing
  staffGroups: 'staffing/groups/',
  qualifications: 'qualifications/',
  userQualifications: 'user-qualifications/',
  isUsernameAvailable: 'is-username-available/',

  // Estimates
  estimates: 'estimates/',
  emailEstimate: 'email-estimate/',
  emailEstimateConfirmation: 'email-estimate-confirmation/',
  downloadEstimate: 'download-estimate/',
  previewEstimate: 'preview-estimate/',
  estimateLineItems: 'estimate-line-items/',
  estimateQualifications: 'estimate-qualifications/',
  createEstimateRevision: 'create-estimate-revision/',
  sellEstimate: 'sell-estimate/',
  snowEstimates: 'snow-estimates/',
  irrigationEstimates: 'irrigation-estimates/',
  lawnEstimates: 'lawn-estimates/',
  projectEstimates: 'project-estimates/',
  estimateOptions: 'estimate-options/',

  // Rate Sheets
  rateSheets: 'rate-sheets/',
  rateSheetItems: 'rate-sheet-items/',
  rateSheetCategories: 'rate-sheet-categories/',
  rateSheetBaseItems: 'rate-sheet-base-items/',
  duplicateRateSheet: 'duplicate-rate-sheet/',

  // Clients
  clients: 'clients/',
  clientContacts: 'client-contacts/',
  clientSearch: 'client-search/',

  // Payroll
  payrollReport: 'payroll-entries/',

  // Projects
  projects: 'projects/',
  snowProjects: 'snow-projects/',
  lawnProjects: 'lawn-projects/',
  constructionProjects: 'construction-projects/',
  softwareProjects: 'software-projects/',
  projectDetails: 'project-details/',
  stickies: 'stickies/',
  outstandingService: 'outstanding-service/',
  newHomeownerLetter: 'new-homeowner-letter/',
  projectsByRouteGroup: 'projects/route_groups/',
  projectGroupings: 'project-groupings/',
  inquiries: 'inquiries/',
  irrigationSystemsReport: 'irrigation-systems-report/',

  // Assets
  inventory: 'inventory/',
  services: 'services/',
  vehicles: 'vehicles/',
  equipment: 'equipment/',

  // Settings
  settings: 'settings/',
  getNextJobNumber: 'next-job-number/',
  getNextDocNumber: 'next-doc-number/',
  divisions: 'divisions/',
  globalOptions: 'global-options/',
  drivewayRatings: 'driveway-ratings/',
  actionTracker: 'action-tracker/',
  ratings: 'ratings/',

  // Schedules
  schedules: 'schedules/',
  scheduleItems: 'schedule-items/',
  routes: 'routes/',
  events: 'events/',
  // routeItems: 'route-items/',
  snowTracker: 'snow-tracker/',
  assignRoutes: 'assign-routes/',

  // Timesheets
  timesheetCategories: 'timesheet-categories/',
  timesheetEntries: 'timesheet-entries/',
  timesheetWorkedOn: 'timesheet-worked-on/',
  timesheetDetails: 'details/',

  // Work Orders
  wos: 'work-orders/',
  wosSearch: 'work-order-search/',
  wosReport: 'work-order-report/',
  crewVisits: 'crew-visits/',
  schedulingLog: 'scheduling-logs/',
  woTypes: 'work-order-types/',
  woLabour: 'work-order-labour/',
  woProduct: 'work-order-products/',
  tasks: 'tasks/',
  sendShowDocuments: 'send-show-documents/',

  // Misc
  releases: 'releases/',

  // Irrigations
  irrigationDashboard: 'irrigation-dashboard/',
  irrigations: 'irrigation-projects/',
  irrigationSearch: 'irrigation-projects-search/',
  SUBDTiers: 'subd-tiers/',
  // SUProjectPreviewList: 'irrigation-su-preview-list/',
  oneTimeNotes: 'one-time-notes/',

  // For these next two, they both require either `su/` or `bd/` added
  // to the end to specify startup or blowdowns. To print a single
  // notice, need to also add the ID of the SUBDTracker object that you want
  // to print a notice for.
  printAllSnailMailNotices: 'print-subd-notices/',
  printOneSnailMailNotice: 'print-subd-notices/',

  // SUBD
  SUBDTrackers: 'subd-tracker/',
  SUBDLocations: 'subd-locations/',
  preview: 'preview/',

  // Files
  files: 'files/',

  // Staging
  streams: 'staging-streams/',
  locations: 'staging-locations',
}

export default endpoints;
